// export const API_URL = 'https://globalinhouse.com/engine-v0.1/encriss/v1';
// export const API_URL = 'http://nutriorg.com/engine-v0.1/encriss/v1'
export const API_URL = window.env.API_URL;